export default {
  "name": "The Quiet Two",
  "slug": "the-quiet-two",
  "path": "/the-quiet-two",
  "componentName" : "TheQuietTwo",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}